<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    class="item-style"
    isRequired="{{isRequired}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="国籍" 
    sub_label="(国家/地区)"
    innerValue="{{country_name_cn}}"
    isDisable="{{isNationlityDisable}}"
  >
    <view slot="input" class="es-content__birth-data-input">
      <view class="es-content__nationality" bindtap="goSelectCountry">
        <view wx:if="{{country_name_cn}}">{{country_name_cn || ''}}</view>
        <view wx:else class="placeholder">请选择</view>
      </view>
      <es-icon name='angle-right' size="16" color="#999999" bind:click="goSelectCountry"></es-icon>
    </view>
  </from-item>

</template>

<script>
import { watch } from "@mpxjs/core";
import store from '@/store'
  import { createComponent } from '@didi/es-mpx-creator'
  import selectCountryPage from '@/pages/contact/selectCountry.mpx?resolve'
  import { hasRequired } from '@/utils'
  import { innerRouter, pagePath } from "@/common/jump";
  createComponent({
    classes: [],
    data: {
      innerValue:{}
    },
    props: {
      value:{
        type: Object,
        value: {}
      },
      isShow:{
        type: Boolean,
        value: false
      },
      isRequiredShow:{
        type: Boolean,
        value: false
      },
      item:Object,
      selectedCardList:Array,
      isNeedCard:Boolean,
      isNationlityDisable: Boolean
      // hasRequired: {
      //   type: Boolean,
      //   value: false
      // }
    },
    computed: {
      ...store.mapState({
        nationality: 'newContacts.nationality',
      }),
      country_name_cn(){
        return this.innerValue?.country_name_cn || ''
      },
      isRequired() {
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      }
    },
    methods: {
      ...store.mapMutations({
        setNationality: 'newContacts.setNationality',
      }),
      //选择国籍页
      goSelectCountry(e) {
        // 国籍字段放在state里面维护
        this.setNationality(this.innerValue)
        innerRouter.push(pagePath().CONTACTSELECTCOUNTRY)
        // if(__mpx_mode__ === 'web'){
        //   innerRouter.push('../pages/selectCountry')
        // }else{
        //   innerRouter.push(selectCountryPage)
        // }
      },
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      //将数据回传
      nationality(newValue) {
        this.$trigger( 'input', {value:newValue} )
      },
    },
    mounted() {
      this.innerValue = this.value
    }
  })
</script>

<style lang='stylus' scoped>
  .item-style
    margin-bottom 16px
  +b('content')
    +e('birth-data-input')
      display flex
      width 100%
      justify-content space-between
      align-items center
    +e('nationality')
      width 100%
      height 100%
      min-height 50px
      line-height 50px
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'from-item': './from-item'
    }
  }
</script>

